// extracted by mini-css-extract-plugin
export var impactedRegions = "impactedRegions-module--impactedRegions--gYgWe";
export var regionListInner = "impactedRegions-module--regionListInner--1kS6k";
export var list = "impactedRegions-module--list--0ei1g";
export var arrow = "impactedRegions-module--arrow--YrWCV";
export var slideUp = "impactedRegions-module--slideUp--bEUGf";
export var slideUpLarge = "impactedRegions-module--slideUpLarge--vCGGn";